import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://sofchef.com.br';
const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-cover.png`;

const SEO = ({ title, description, path = '/', ogImage = DEFAULT_OG_IMAGE, jsonLd }) => {
  const canonical = `${SITE_URL}${path}`;
  const fullTitle = title.includes('SofChef') ? title : `${title} | SofChef`;

  const jsonLdList = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content="SofChef" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLdList.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
